import React from 'react';

import MenuItem from '@mui/material/MenuItem';
import { type MenuItemProps } from '@mui/material/MenuItem/MenuItem';

import { ButtonMenuContext } from './ButtonMenu';

type ButtonMenuItemProps = MenuItemProps & {
    clickAction?: string;
};

const ButtonMenuItem: React.FC<ButtonMenuItemProps> = (props) => {
    const { children, clickAction } = props;
    const menuItemProps = (() => {
        const newProps: any = { ...props };
        delete newProps.clickAction;
        return newProps;
    })() as MenuItemProps;
    return (
        <ButtonMenuContext.Consumer>
            {(value) => (
                <MenuItem
                    {...menuItemProps}
                    data-action={clickAction}
                    onClick={(e) => {
                        if (value.handleItemClick) {
                            value.handleItemClick(e);
                        }
                    }}
                >
                    {children}
                </MenuItem>
            )}
        </ButtonMenuContext.Consumer>
    );
};

export default ButtonMenuItem;
